import React, { useState, useEffect, useRef } from 'react';
import { Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useParams } from 'react-router-dom/cjs/react-router-dom';

import * as api from '~/Services/Service';
import ListaAtividadesAgenda from './ListaAtividadesAgenda/ListaAtividadesAgenda';
import FiltrosAgenda from './FiltrosAgenda/FiltrosAgenda';
import CalendarioAgenda from './CalendarioAgenda/CalendarioAgenda';
import CabecalhoAgenda from './CabecalhoAgenda/CabecalhoAgenda';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'tui-calendar/dist/tui-calendar.css';
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';
import './agenda.css';

export default function AgendaLeads() {
  const { agendaIndividual } = useParams();
  
  const [atividades, setAtividades] = useState([]);
  const [atividadesFiltradas, setAtividadesFiltradas] = useState([]);
  const [atividadesCalendario, setAtividadesCalendario] = useState([]);
  const [filtros, setFiltros] = useState({});
  const [leadsOptions, setLeadsOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dataSelecionada, setDataSelecionada] = useState(() => new Date());
  const [isfiltroNavBarOpen, setIsfiltroNavBarOpen] = useState(false);
  
  const valorDataSelecionadaAnterior = useRef();

  const buscarAtividades = async (filtrar_por_mes = false) => {
    setLoading(true);
    try {
      const filtro = {
        ...filtros,
        data_selecionada: moment(dataSelecionada).format('YYYY-MM-DDTHH:mm:ss'),
        filtrar_por_mes,
        buscar_individual: agendaIndividual,
      };
      
      const response = await api.BuscarAgendaAtividades(filtro);
      setAtividades(response);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const criarLeadsOptions = (atividades) => {
    const leadsUnicos = [];
    const codigosAdicionados = new Set();

    atividades.forEach(item => {
      if (!codigosAdicionados.has(item.codigo_prospecto)) {
        leadsUnicos.push({
          value: item.codigo_prospecto,
          label: item.nome_prospecto,
        });
        codigosAdicionados.add(item.codigo_prospecto);
      }
    });
    
    setLeadsOptions(leadsUnicos);
  };

  const aplicarFiltros = () => {
    let filtradas = Array.isArray(atividades) ? atividades : [];
    const { atendente, corretor, codigo_lead, etapa, tipo_atividade } = filtros || {};

    if (codigo_lead) {
      filtradas = filtradas.filter(a =>
        String(a.codigo_prospecto) === String(codigo_lead)
      );
    }

    if (tipo_atividade) {
      filtradas = filtradas.filter(a =>
        String(a.tipo_atividade) === String(tipo_atividade) ||
        (String(tipo_atividade) === '3' && a.descricao_tipo_atividade === 'Tarefa') ||
        (String(tipo_atividade) === '5' && a.descricao_tipo_atividade === 'Visita')
      );
    }

    if (etapa) {
      filtradas = filtradas.filter(a =>
        String(a.atividade_etapa) === String(etapa) ||
        String(a.etapa) === String(etapa)
      );
    }

    if (corretor) {
      filtradas = filtradas.filter(a =>
        String(a.codigo_corretor) === String(corretor) ||
        String(a.codigo_responsavel) === String(corretor)
      );
    }

    if (atendente) {
      filtradas = filtradas.filter(a =>
        String(a.codigo_atendente) === String(atendente) ||
        String(a.codigo_pdv) === String(atendente)
      );
    }

    setAtividadesCalendario(filtradas);

    let filtradasPorDia = filtradas;
    filtradasPorDia = filtradasPorDia.filter(a => {
      try {
        const atividadeObj = JSON.parse(a.atividade);
        return atividadeObj.situacao !== 'Cancelado';
      } catch {
        return a.atividade_etapa !== 4;
      }
    });

    if (dataSelecionada) {
      const dataSelecionadaFormatada = moment(dataSelecionada).format('YYYY-MM-DD');
      filtradasPorDia = filtradasPorDia.filter(a =>
        moment(a.data_conclusao).format('YYYY-MM-DD') === dataSelecionadaFormatada
      );
    }

    filtradasPorDia.sort((a, b) => {
      const dataA = new Date(a.data_conclusao);
      const dataB = new Date(b.data_conclusao);
      return dataA - dataB;
    });

    setAtividadesFiltradas(filtradasPorDia);
  };

  const handleChangeFiltros = (campo, value) => {
    setFiltros(prev => ({ ...prev, [campo]: value }));
  };

  const handleChangeDataSelecionada = (value) => {
    setDataSelecionada(value);
  };

  const reconstruirAtividades = (response) => {
    if (!response || !response.nova_atividade) return;

    setAtividades(prevAtividades =>
      prevAtividades.map(item =>
        item.codigo_atividade === response.nova_atividade.codigo_atividade
          ? response.nova_atividade
          : item
      )
    );
  };

  const toggleFiltros = () => {
    setIsfiltroNavBarOpen(prev => !prev);
  };

  useEffect(() => {
    buscarAtividades(true);
  }, []);

  useEffect(() => {
    if (
      valorDataSelecionadaAnterior.current &&
      moment(valorDataSelecionadaAnterior.current).format('MM') !== moment(dataSelecionada).format('MM')
    ) {
      buscarAtividades(true);
    }
    valorDataSelecionadaAnterior.current = dataSelecionada;
  }, [dataSelecionada]);

  useEffect(() => {
    criarLeadsOptions(atividades);
  }, [atividades]);

  useEffect(() => {
    setFiltros(prev => ({ ...prev, data_selecionada: dataSelecionada }));
  }, [dataSelecionada]);

  useEffect(() => {
    aplicarFiltros();
  }, [atividades, filtros, dataSelecionada]);

  return (
    <Container fluid className="bg-white p-3 p-md-4">
      <div className="mb-3">
        <CabecalhoAgenda
          dataSelecionada={dataSelecionada}
          changeDataSelecionada={handleChangeDataSelecionada}
          atividadesFiltradas={atividadesFiltradas}
          toggleSidebar={toggleFiltros}
          filtros={filtros}
        />
      </div>

      <div className="row g-3">
        <div className="col-12 col-lg-6">
          <div className="agenda-card h-100">
            <div style={{ marginBottom: 10 }}>
              <span
                style={{
                  backgroundColor: '#419AEF',
                  color: '#fff',
                  padding: '6px 16px',
                  borderRadius: 20,
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                Atividades do Mês
              </span>
            </div>
            <CalendarioAgenda
              atividades={atividadesCalendario}
              setAtividades={setAtividades}
              dataSelecionada={dataSelecionada}
              changeDataSelecionada={handleChangeDataSelecionada}
            />
          </div>
        </div>

        <div className="col-12 col-lg-6">
          <div className="agenda-card h-100">
            <div style={{ marginBottom: 10 }}>
              <span
                style={{
                  backgroundColor: '#419AEF',
                  color: '#fff',
                  padding: '6px 16px',
                  borderRadius: 20,
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                Atividades do Dia
              </span>
            </div>
            <ListaAtividadesAgenda
              atividadesFiltradas={atividadesFiltradas}
              loading={loading}
              reconstruirAtividades={reconstruirAtividades}
            />
          </div>
        </div>
      </div>

      <FiltrosAgenda
        filtros={filtros}
        handleChangeFiltros={handleChangeFiltros}
        leadsOptions={leadsOptions}
        dataSelecionada={dataSelecionada}
        changeDataSelecionada={handleChangeDataSelecionada}
        isOpen={isfiltroNavBarOpen}
        onClose={toggleFiltros}
      />
    </Container>
  );
}